import React, { useState, Fragment } from "react"
import { loadStripe } from "@stripe/stripe-js"
import { STRIPE_KEY } from "../utils/helpers"
import Layout from "../elements/Layout"
import Helmet from "../elements/Helmet"
import Welcome from "../components/index/Welcome"
import Logo from "../components/index/Logo"
import Order from "../components/index/Order"
import Payment from "../components/index/Payment"
import Receipt from "../components/index/Receipt"
import Footer from "../components/index/Footer"

const stripePromise = loadStripe(STRIPE_KEY)

const Index = () => {
  const [started, setStarted] = useState(0)
  const [submitted, setSubmitted] = useState(null)
  const [open, setOpen] = useState(true)

  const handleStarted = status => {
    setStarted(status)
  }

  const handleSubmitted = obj => {
    setSubmitted(obj)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Layout>
      <Helmet index={true} descr="Order items from our take menu." />
      {open && <Welcome close={handleClose} />}
      <Logo />
      <Fragment>
        {started && submitted ? (
          <Receipt details={submitted} />
        ) : started ? (
          <Payment
            stripePromise={stripePromise}
            started={handleStarted}
            submitted={handleSubmitted}
          />
        ) : (
          <Order started={handleStarted} />
        )}
      </Fragment>
      <Footer />
    </Layout>
  )
}

export default Index
